import React, {useEffect, useState} from "react";
import {GlobalConstants} from "../../data/GlobalConstants";
import {isEmpty, isObject} from "../../util/is";
import {FormControl} from "@mui/material";
import {useController, useWatch} from "react-hook-form";


const FileInputController = ({ required, rules, identificador, disabled, inputProps }) => {


  const { field } = useController({ control: inputProps.control , name: identificador });
  const [value, setValue] = React.useState("");
  const valor = useWatch({
    control: inputProps.control,
    name: identificador
  })

  return (

    <div className="d-flex">
      <div className="mr-2 mb-2">
        <img src={isObject(valor)? URL.createObjectURL(valor[0]):
          isEmpty(valor)? `${GlobalConstants.urlImagenPlaceHolder}` :
            valor?.includes('http')? valor : `${GlobalConstants.urlUploadImage}${valor}`}
             style={{width: 100,
               height: 100,
               borderRadius: 10,
               objectFit: 'cover'}} />
      </div>
      <div className="w-100">
      <input type="file" className="form-control-input-file"
             value={value}
             onChange={(e) => {
               //console.log(e.target.files)
               //console.log(e.target.files[0].name)
               //console.log(e.target.value)
               setValue(e.target.value);
               field.onChange(e.target.files);
             }}
             name={identificador}
             style={{padding: 7}}
             disabled={disabled}
      />
      <label className="titleForm p-1">
        {`Imagen: ${isObject(valor)? !isEmpty(valor[0]?.name)? valor[0]?.name : 'No tienes ninguna imagen guardada' : isEmpty(valor) ?
          'No tienes ninguna imagen guardada' : valor}`}
      </label>
      </div>
    </div>
  );
};

const ImagePicker = ({label="Label", value, disabled = false, identificador, handleChange, required = false, className="classNameImagePicker", width = ''
                       , inputProps = {}, rules = {}, customError = null}) => {


    /*const handleChangeFile = ({name, files}) => {
        handleChange({name, file: files[0]})
    }*/


    return(

        <FormControl  key={`keyImagePicker${identificador}`}  variant="outlined" className={`my-1 ${className}`}>


                <div className="mx-0 my-3 text-center text-muted content-divider divider-form">
                    <span />
                </div>
                <label className="pl-2 titleForm">{`${required ? `*${label}` : `${label}`}`}</label>
                <div className="w-100">
                  {
                    ("control" in inputProps) &&
                    <FileInputController required={required} rules={rules} identificador={identificador}
                                         disabled={disabled} inputProps={inputProps}/>
                  }
                </div>
                {
                    (!isEmpty(customError) || required) &&
                    <span className="mt-2 titleForm panelColorError">{customError}</span>
                }
        </FormControl>

    )

}




export default ImagePicker;
